import { MaritalStatusEnum } from "../../Types/Enums/MaritalStatusEnum";

export const MARITAL_STATUS = [
  { id: MaritalStatusEnum.SINGLE, labels: { 0: "Soltero(a)", 1: "Single" } },
  { id: MaritalStatusEnum.MARRIED, labels: { 0: "Casado(a)", 1: "Married" } },
  { id: MaritalStatusEnum.DIVORCED, labels: { 0: "Divorciado(a)", 1: "Divorced" } },
  { id: MaritalStatusEnum.WIDOWED, labels: { 0: "Viudo(a)", 1: "Widowed" } },
  { id: MaritalStatusEnum.DOMESTIC_PARTNERSHIP, labels: { 0: "Unión Libre", 1: "Free Union" } }
];